import React from "react";
import InfoIcon from "@mui/icons-material/Info";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HelpIcon from "@mui/icons-material/Help";
import WarningIcon from "@mui/icons-material/Warning";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ErrorIcon from "@mui/icons-material/Error";
import PropTypes from "prop-types";
import { SeverityType } from "core/enums";

export const SeverityIcon = ({ severityId, colour }) => {
  switch (severityId) {
    case SeverityType.UNASSIGNED:
      return <HelpIcon htmlColor={colour} />;
    case SeverityType.SYSTEM:
      return <InfoIcon htmlColor={colour} />;
    case SeverityType.GOOD:
      return <CheckCircleIcon htmlColor={colour} />;
    case SeverityType.WARNING:
      return <WarningIcon htmlColor={colour} />;
    case SeverityType.PROGRESSED:
      return <ErrorOutlineIcon htmlColor={colour} />;
    case SeverityType.CRITICAL:
      return <ErrorIcon htmlColor={colour} />;
    default:
      return null;
  }
};

SeverityIcon.propTypes = {
  severityId: PropTypes.number.isRequired,
  colour: PropTypes.string
};
